export default "__VITE_ASSET__DEXV70TI__"